import Backbone from "backbone";
import $ from "jquery";
import SharedDispatcher from "../../../../Assets/javascripts/common/others/SharedDispatcher";
// import MediaElement from "../../../../Assets/javascripts/vendors/mediaelement";
import { MediaElementJS } from "../../../../Assets/javascripts/common/dynamic-imports/MediaElementJS";

export default Backbone.View.extend({
  /**
    * @class AudioPlayerView
    *
    * @augments Backbone.View
    * @constructs
    *
    * Set elements, indexes, initialize mediaelement and render.
    */
  initialize: function () {
    // set elements
    this.$audio = this.$(".js-AudioPlayer-audio");
    this.$controls = this.$(".js-AudioPlayerControls");
    this.$tracks = this.$(".js-AudioPlayerTrackListItem");
    this.$volume = this.$(".js-AudioPlayerControls-volume");

    // set track indexes
    this.minIndex = 0;
    this.maxIndex = this.$tracks.length - 1;
    this.index = this.minIndex;
    this.lastIndex = null;

    // initialize volume slider
    this.initializeVolumeSlider();

    // initialize timeline slider

    // initialize mediaelement with first track
    const url = $(this.$tracks[this.index]).attr("data-url");
    this.initializeMediaELement(url);

    // initial render
    this.render();
  },

  events: {
    "click .js-AudioPlayerTrackListItem": "playClicked",
    "click .js-AudioPlayerControls-play": "playPause",
    "click .js-AudioPlayerControls-previous": "playPrev",
    "click .js-AudioPlayerControls-next": "playNext",
    "click .js-AudioPlayerControls-mute": "mute"
  },

  /**
   * Initialize rangeslider on volume element and register change listener.
   * @method
   * @returns {void}
   */
  initializeVolumeSlider: function () {
    this.$volume.rangeslider({
      polyfill: false,
      onSlide: this.onVolumeUpdate.bind(this)
    });

    this.$volume.on('change', this.onVolumeUpdate.bind(this));
  },

  /**
   * Report mediaelement loading success, store mediaelement instance and add event listeners.
   *
   * @method
   * @params {object} - mediaelement instance
   * @params {object} - mediaelement audio element
   * @listens module:mediaelement~event:success
   */
  onMediaElementSuccess: function (mediaElement, el) {
    // store medialement instance
    this.mediaElement = mediaElement;

    // initialize mediaelement events
    this.mediaElement.addEventListener("loadeddata", this.onMediaElementLoadeddata.bind(this));
    this.mediaElement.addEventListener("timeupdate", this.onMediaElementTimeupdate.bind(this));
    this.mediaElement.addEventListener("ended", this.onMediaElementEnded.bind(this));
  },

  /**
   * Report medialement loading error.
   *
   * @method
   * @params {object} - mediaelement audio element
   * @listens module:mediaelement~event:error
   */
  onMediaElementError: function (el) {
    SharedDispatcher.trigger('flashmessage:show');
  },

  /**
   * Report medialement data loading, render duration
   *
   * @method
   * @params {
   * @listens module:mediaelement~event:loadeddata
   */
  onMediaElementLoadeddata: function (e) {
    this.renderDuration(Math.round(e.target.duration || e.srcElement.duration));
  },

  /**
   * Report medialement time update, render duration progress and played duration
   *
   * @method
   * @listens module:mediaelement~event:timeupdate
   */
  onMediaElementTimeupdate: function (e) {
    this.renderDurationProgress(this.mediaElement.currentTime * 100 / this.mediaElement.duration);
    this.renderPlayedDuration(Math.round(this.mediaElement.currentTime));
  },

  /**
   * Report medialement end, play next track
   *
   * @method
   * @listens module:mediaelement~event:ended
   */
  onMediaElementEnded: function () {
    this.playNext();
  },

  /**
   * Report medialement volume update.
   * Return immediately if mediaelement falsy
   * Handle
   *
   * @method
   * @listens module:mediaelement~event:volumeupdate
   */
  onVolumeUpdate: function (e) {
    if (!this.mediaElement) {
      return;
    }

    // if polyfill in use arg is a jquery event else a number
    if (typeof e == "number") {
      this.mediaElement.setVolume(e / 100);
    } else {
      this.mediaElement.setVolume($(e.currentTarget).val() / 100);
    }
  },

  /**
   * Initialize mediaelement instance, set track url as audio src.
   *
   * params {String} - track url
   * @listens module:mediaelement~event:timeupdate
   */
  initializeMediaELement: function (url) {
    this.$audio.attr('src', url);

    const mediaElementJS = new MediaElementJS(this.$audio[0], {
      success: this.onMediaElementSuccess.bind(this),
      plugins: []
    });
    mediaElementJS.run();
  },

  /**
   * returns whether we've reached the maximum track index
   *
   * @returns {Boolean}
   */
  canPlayNext: function () {
    return this.index < this.maxIndex;
  },

  /**
   * returns whether we've reached the minimum track index
   *
   * @returns {Boolean}
   */
  canPlayPrev: function () {
    return this.index > 0;
  },

  /**
   * Set audioplayer track src
   */
  mediaSetSrc: function (el) {
    const url = $(el).attr("data-url");
    if (url !== "" && this.mediaElement) {
      this.mediaElement.setSrc(url);
      this.mediaElement.play();
    }
    else {
      this.onMediaElementError();
      return;
    }
  },

  /**
   * Report audioplayer play next.
   *
   * @method
   * @listens module:mediaelement~event:playNext
   */
  playNext: function () {
    if (this.canPlayNext()) {
      this.lastIndex = this.index;
      this.index += 1;

      this.mediaSetSrc($(this.$tracks[this.index]));

      this.render();
    }
  },

  /**
   * Report audioplayer play prev.
   *
   * @method
   * @listens module:mediaelement~event:playPrev
   */
  playPrev: function () {
    if (this.canPlayPrev()) {
      this.lastIndex = this.index;
      this.index -= 1;

      this.mediaSetSrc($(this.$tracks[this.index]));

      this.render();
    }
  },

  /**
   * Report audioplayer track click.
   *
   * @method
   * @listens module:audioplayer~event:playClick
   */
  playClicked: function (e) {
    this.lastIndex = this.index;
    this.index = parseInt($(e.currentTarget).attr("data-index"));

    this.mediaSetSrc($(this.$tracks[this.index]));

    this.render();
  },

  /**
   * Report audioplayer play/pause click.
   *
   * @method
   * @listens module:audioplayer~event:playPause
   */
  playPause: function () {
    if (this.mediaElement) {
      if (this.mediaElement.paused) {
        this.mediaElement.play();
      } else {
        this.mediaElement.pause();
      }
    }
    else {
      this.onMediaElementError();
      return;
    }

    this.render();
  },

  /**
   * Report audioplayer mute update, toggle mute state.
   *
   * @method
   * @listens module:audioplayer~event:mute{void}
   */
  mute: function () {
    if (document.createElement('audio').canPlayType && this.mediaElement) {
      if (this.mediaElement.muted) {
        this.mediaElement.setMuted(false);
      } else {
        this.mediaElement.setMuted(true);
      }
    }

    this.render()
  },

  /**
   * Update duration element.
   *
   * @returns {void}
   */
  renderDuration: function (time) {
    var minutes = Math.floor(time / 60);
    var seconds = time - minutes * 60;

    // add zero padding
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    this.$controls.find(".js-AudioPlayerControls-duration").text(minutes + ":" + seconds);
  },

  /**
   * Update duration progress element.
   *
   * @returns {void}
   */
  renderDurationProgress: function (percent) {
    this.$controls.find(".js-AudioPlayerControls-timelineProgress").css("width", percent + "%");
  },

  /**
   * Update played duration element.
   *
   * @returns {void}
   */
  renderPlayedDuration: function (time) {
    var minutes = Math.floor(time / 60);
    var seconds = time - minutes * 60;

    // add zero padding
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    this.$controls.find(".js-AudioPlayerControls-playedDuration").text(minutes + ":" + seconds);
  },

  /**
   * Update title element.
   *
   * @returns {void}
   */
  renderTitle: function (title) {
    this.$controls.find(".js-AudioPlayerControls-trackTitle").text(title);
  },

  /**
   * Propagates changes to the dom.
   *
   * @method
   * @returns {void}
   */
  render: function () {
    // update controls title
    this.renderTitle($(this.$tracks[this.index]).attr("data-title"));

    // remove active class from last item if exists
    if (this.lastIndex != this.index) {
      $(this.$tracks[this.lastIndex]).removeClass("AudioPlayerTrackListItem--active");
    }

    // set active class to current track
    $(this.$tracks[this.index]).addClass("AudioPlayerTrackListItem--active")

    // enable or disable prev/next
    this.$(".js-AudioPlayerControls-previous").prop("disabled", !this.canPlayPrev());
    this.$(".js-AudioPlayerControls-next").prop("disabled", !this.canPlayNext());

    // set playing class to play button
    if (!this.mediaElement || this.mediaElement.paused) {
      this.$(".js-AudioPlayerControls-play").removeClass("AudioPlayerControls-play--playing");
    } else {
      this.$(".js-AudioPlayerControls-play").addClass("AudioPlayerControls-play--playing");
    }

    // update mute
    if (document.createElement('audio').canPlayType && this.mediaElement) {
      if (this.mediaElement.muted) {
        this.$(".js-AudioPlayerControls-mute").addClass("AudioPlayerControls-mute--active");
      } else {
        this.$(".js-AudioPlayerControls-mute").removeClass("AudioPlayerControls-mute--active");
      }
    }
  }
});
